import cn from 'classnames';
import styles from 'styles/login.module.scss';

/* i18n */
import { useIntl } from 'react-intl';

import { TextField, Box } from "@material-ui/core";

import { passwordTests } from 'lib/utils';

function Password({
  value,
  error,
  formikTouched,
  formikError,
  onChange,
  onBlur
}) {

  const intl = useIntl();

  const passwordLowercase = passwordTests['lowercase'].test(value);
  const passwordUppercase = passwordTests['uppercase'].test(value);
  // Special character list from:
  // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
  const passwordSpecial = passwordTests['special'].test(value);
  const passwordDigit = passwordTests['digit'].test(value);
  const passwordLength = value.length >= passwordTests['length'];
  const whiteSpace = value.length >= 1 && passwordTests['nospaces'].test(value);

  return (
    <>
      <Box style={{marginBottom: 4}}>
        <TextField
          FormHelperTextProps={{
            className: styles.helperText
          }}
          error={formikTouched && Boolean(formikError)}
          fullWidth
          helperText={formikTouched && formikError}
          label={intl.formatMessage({id:'forms.signIn.password'})}
          name="password"
          onChange={onChange}
          placeholder={intl.formatMessage({id:'forms.signIn.enterPassword'})}
          type="password"
          value={value}
          variant="filled"
          inputProps={{
            title: intl.formatMessage({id:'forms.signIn.password'})
          }}
        />
      </Box>
      {error.length > 0 && (
        <div className={styles.errorMessage__container}>
          <label className={styles.errorMessage}>{error}</label>
        </div>
      )}
      <div className={styles.errorMessage__container}>
        <ul className={styles.passwordRequirementsList}>
          <li className={cn({
            [styles.passwordRequirementOk]: passwordLowercase,
            [styles.passwordRequirementError]: !passwordLowercase,
          })}>{intl.formatMessage({id:'forms.signUp.passwordRequirementLowercase'})}</li>
          <li className={cn({
            [styles.passwordRequirementOk]: passwordUppercase,
            [styles.passwordRequirementError]: !passwordUppercase,
          })}>{intl.formatMessage({id:'forms.signUp.passwordRequirementUppercase'})}</li>
          <li className={cn({
            [styles.passwordRequirementOk]: passwordSpecial,
            [styles.passwordRequirementError]: !passwordSpecial,
          })}>{intl.formatMessage({id:'forms.signUp.passwordRequirementSpecialCharacter'})}</li>
          <li className={cn({
            [styles.passwordRequirementOk]: passwordDigit,
            [styles.passwordRequirementError]: !passwordDigit,
          })}>{intl.formatMessage({id:'forms.signUp.passwordRequirementNumber'})}</li>
          <li className={cn({
            [styles.passwordRequirementOk]: passwordLength,
            [styles.passwordRequirementError]: !passwordLength,
          })}>{intl.formatMessage({id:'forms.signUp.passwordRequirementMinLength'})}</li>
          <li className={cn({
            [styles.passwordRequirementOk]: whiteSpace,
            [styles.passwordRequirementError]: !whiteSpace,
          })}>{intl.formatMessage({id:'forms.signUp.passwordRequirementNoSpaces'})}</li>
        </ul>
      </div>
    </>
  )
}

export default Password;